import { Box, Container, Link as MUILink, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { ROUTES } from "@/utils/navigation";
import useResponsive from "@/hooks/useResponsive";

const TopBar = () => {
  const isDesktop = useResponsive("up", "lg");

  if (!isDesktop) {
    return null;
  }

  return (
    <Box
      sx={{
        backgroundColor: "#FF6B00",
        width: "100%",
        height: 56,
        display: "flex",
        alignItems: "center",
      }}
    >
      <Container>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: 3,
          }}
        >
          <MUILink
            component={Link}
            to={ROUTES.findDealer}
            sx={{
              color: "white",
              textDecoration: "none",
              "&:hover": {
                color: "white",
                textDecoration: "none",
              },
              "&:focus": {
                color: "white",
                textDecoration: "none",
              },
              "&:active": {
                color: "white",
                textDecoration: "none",
              },
              "&:visited": {
                color: "white",
                textDecoration: "none",
              },
            }}
          >
            <Typography
              sx={{
                fontFamily: "Mulish",
                fontWeight: 700,
                fontSize: 14,
                lineHeight: "125%",
                letterSpacing: 0,
                textAlign: "center",
              }}
            >
              Find Installers
            </Typography>
          </MUILink>

          <Box
            sx={{
              width: "1px",
              height: "16px",
              backgroundColor: "rgba(255, 255, 255, 0.5)",
            }}
          />

          <MUILink
            component={Link}
            to={ROUTES.legacyLogin}
            sx={{
              color: "white",
              textDecoration: "none",
              "&:hover": {
                color: "white",
                textDecoration: "none",
              },
              "&:focus": {
                color: "white",
                textDecoration: "none",
              },
              "&:active": {
                color: "white",
                textDecoration: "none",
              },
              "&:visited": {
                color: "white",
                textDecoration: "none",
              },
            }}
          >
            <Typography
              sx={{
                fontFamily: "Mulish",
                fontWeight: 700,
                fontSize: 14,
                lineHeight: "125%",
                letterSpacing: 0,
                textAlign: "center",
              }}
            >
              Log In
            </Typography>
          </MUILink>
        </Box>
      </Container>
    </Box>
  );
};

export default TopBar;
